<template>
  <div>
    <VRow>
      <VBtn
        class="mb-2 header__link text-capitalize d-flex align-items-center"
        color="secondary"
        text
        @click="$emit('toStartStep')"
      >
        <div class="d-flex align-items-center">
          <VIcon class="mr-2">
            mdi-arrow-left
          </VIcon>
          <span
            v-if="!this.$vuetify.breakpoint.smAndDown"
            class="body-1 back-btn__text"
          >
            {{ $t('authForm.back') }}
          </span>
        </div>
      </VBtn>
    </VRow>
    <ValidationObserver
      ref="changePassword"
      v-slot="{ invalid }"
      name="changePassword"
    >
      <VRow justify="center">
        <VCol
          class="px-2 pb-2 d-flex align-center pt-0"
          cols="12"
        >
          <div>
            <span class="body-1">
              {{ $t('authForm.phoneNumber') }}
            </span>
          </div>
          <div class="ml-2">
            <span class="body-bold">
              {{ phone }}
            </span>
          </div>
        </VCol>
        <VCol
          class="px-2 pb-6 d-flex pt-0"
          cols="12"
        >
          <span class="body-2">
            {{ $t('authForm.setUpYourNewPassword') }}
          </span>
        </VCol>
        <VCol
          class="px-2 pb-2 pt-0"
          cols="12"
        >
          <ValidationProvider
            ref="newPassword"
            v-slot="{ errors, ariaInput }"
            name="newPassword"
            :rules="{ required: true, min: 6, max: 40, withoutSpaces: /^\S*$/ }"
            mode="aggressive"
          >
            <VTextField
              v-bind="ariaInput"
              v-model="newPassword"
              :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showNewPassword ? 'text' : 'password'"
              :hide-details="!errors.length"
              name="input-10-2"
              :label="$t('authForm.newPassword')"
              :error="!!errors.length"
              :error-messages="validationErrorResolve(errors[0])"
              class="body-1 pt-0"
              @click:append="showNewPassword = !showNewPassword"
            />
          </ValidationProvider>
        </VCol>
        <VCol
          class="px-2 pb-2 pt-0"
          cols="12"
        >
          <ValidationProvider
            ref="confirmPassword"
            v-slot="{ errors, ariaInput }"
            name="confirmPassword"
            :rules="{ required: true, equalsPassword: newPassword }"
            mode="aggressive"
          >
            <VTextField
              v-bind="ariaInput"
              v-model="confirmedPassword"
              :append-icon="showConfirmedPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showConfirmedPassword ? 'text' : 'password'"
              :hide-details="!errors.length"
              name="input-10-2"
              :label="$t('authForm.confirmPassword')"
              :error="!!errors.length"
              :error-messages="validationErrorResolve(errors[0])"
              class="body-1 pt-0"
              @click:append="showConfirmedPassword = !showConfirmedPassword"
            />
          </ValidationProvider>
        </VCol>
        <VCol
          class="px-2 pb-3 pt-0"
          cols="12"
          col="12"
        >
          <VBtn
            class="w-100 border-radius-8"
            dark
            :class="{'disabled': invalid }"
            large
            color="brandingPrimary"
            @click="onSubmitCreatePassword"
          >
            <span class="button">
              {{ $t('general.next') }}
            </span>
          </VBtn>
        </VCol>
      </VRow>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
export default {
  name: 'CreationPasswordStep',
  // Kept in Options data so template ref="newPassword" stays on $refs (v-model uses this).
  data() {
    return {
      newPassword: '',
    };
  },
};
</script>

<script setup lang="ts">
import { ref } from 'vue';
import { useValidationError, useVm } from '../../../composables';

defineProps({
  phone: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['trackGtmEventForUserCreatedByOperator', 'createPassword']);

const { validationErrorResolve } = useValidationError();
const vm = useVm() as { newPassword: string };

const showNewPassword = ref(false);
const showConfirmedPassword = ref(false);
const confirmedPassword = ref('');

function onSubmitCreatePassword() {
  emit('trackGtmEventForUserCreatedByOperator');
  emit('createPassword', vm.newPassword);
}
</script>
